import { createAction, handleActions } from 'redux-actions';

export const setSelectedExperienceOrder = createAction('SET_SELECTED_EXPERIENCE_ORDER');
export const setUserCurrentLocation = createAction('SET_USER_CURRENT_LOCATION');
export const setSelectedExperience = createAction('SET_SELECTED_EXPERIENCE');
export const setSelectedExperienceOwner = createAction('SET_SELECTED_EXPERIENCE_OWNER');

const INITIAL_STATE = {
  selectedExperienceOrder: [],
  userCurrentLocation: {
    latitude: 0,
    longitude: 0,
  },
  selectedExperience: null,
  selectedExperienceOwner: null,
};

export default handleActions(
  {
    SET_SELECTED_EXPERIENCE_ORDER: (state, action) => ({ ...state, selectedExperienceOrder: action.payload }),
    SET_USER_CURRENT_LOCATION: (state, action) => ({ ...state, userCurrentLocation: action.payload }),
    SET_SELECTED_EXPERIENCE: (state, action) => ({ ...state, selectedExperience: action.payload }),
    SET_SELECTED_EXPERIENCE_OWNER: (state, action) => ({ ...state, selectedExperienceOwner: action.payload }),
  },
  INITIAL_STATE
);
